"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.styles = void 0;

var styles = function styles(theme) {
  return {
    root: {},
    repeaterButton: {
      margin: "8px 0 0 8px"
    },
    addFieldIcon: {
      marginRight: theme.spacing(1)
    },
    addButton: {
      marginTop: theme.spacing(2)
    },
    fullWidth: {
      flexGrow: 1
    }
  };
};

exports.styles = styles;